import {
  GlobalEvents,
  SnippetElement,
  Theme,
  defineElement,
  liquidValue,
  on,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-line-item/common-line-item.ts
var CommonLineItem = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  open() {
    return __async(this, null, function* () {
      this.infoPopover.open();
      this.infoPopover.style.top = `-${this.infoPopover.getBoundingClientRect().height}px`;
      this.isOpen = true;
    });
  }
  close() {
    return __async(this, null, function* () {
      this.infoPopover.close();
      this.isOpen = false;
    });
  }
  toggle() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        yield this.close();
      } else {
        yield this.open();
      }
    });
  }
  addQuantity() {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.increaseBtn) == null ? void 0 : _a.setAttribute("loading", "");
      this.variantQty.valueAsNumber += 1;
      yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
      GlobalEvents.emit("cart:updated");
      (_b = this.increaseBtn) == null ? void 0 : _b.removeAttribute("loading");
    });
  }
  reduceQuantity() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.variantQty.valueAsNumber == 1) {
        yield this.removeItem();
      } else {
        (_a = this.decreaseBtn) == null ? void 0 : _a.setAttribute("loading", "");
        this.variantQty.valueAsNumber -= 1;
        yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
        GlobalEvents.emit("cart:updated");
        (_b = this.decreaseBtn) == null ? void 0 : _b.removeAttribute("loading");
      }
    });
  }
  updateQuantity(elm) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      (_a = this.increaseBtn) == null ? void 0 : _a.setAttribute("loading", "");
      (_b = this.decreaseBtn) == null ? void 0 : _b.setAttribute("loading", "");
      yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
      GlobalEvents.emit("cart:updated");
      (_c = this.increaseBtn) == null ? void 0 : _c.removeAttribute("loading");
      (_d = this.decreaseBtn) == null ? void 0 : _d.removeAttribute("loading");
    });
  }
  removeItem() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.removeBtn) == null ? void 0 : _a.setAttribute("loading", "");
      yield Theme.Cart.removeLineItem(this.key);
      GlobalEvents.emit("cart:updated");
    });
  }
};
__decorateClass([
  liquidValue("item.key")
], CommonLineItem.prototype, "key", 2);
__decorateClass([
  query("[data-cart-quantity]")
], CommonLineItem.prototype, "variantQty", 2);
__decorateClass([
  query("[data-remove]")
], CommonLineItem.prototype, "removeBtn", 2);
__decorateClass([
  query("[data-cart-quantity-plus]")
], CommonLineItem.prototype, "increaseBtn", 2);
__decorateClass([
  query("[data-cart-quantity-minus]")
], CommonLineItem.prototype, "decreaseBtn", 2);
__decorateClass([
  query("[data-info-popover]")
], CommonLineItem.prototype, "infoPopover", 2);
__decorateClass([
  onClick("[data-info-btn]")
], CommonLineItem.prototype, "toggle", 1);
__decorateClass([
  onClick("[data-cart-quantity-plus]")
], CommonLineItem.prototype, "addQuantity", 1);
__decorateClass([
  onClick("[data-cart-quantity-minus]")
], CommonLineItem.prototype, "reduceQuantity", 1);
__decorateClass([
  on("change", "[data-cart-quantity]")
], CommonLineItem.prototype, "updateQuantity", 1);
__decorateClass([
  onClick("[data-remove]")
], CommonLineItem.prototype, "removeItem", 1);
CommonLineItem = __decorateClass([
  defineElement("common-line-item")
], CommonLineItem);
export {
  CommonLineItem
};
